import { gql } from "@apollo/client";

export const ADMIN_NOTIFICATION_LOG_MONITORING = gql`
  query AdminNotificationLogMonitoring(
    $status: String
    $type: String
    $userId: String
    $first: Int
    $skip: Int
  ) {
    adminNotificationLogMonitoring(
      status: $status
      type: $type
      userId: $userId
      first: $first
      skip: $skip
    ) {
      entries {
        userId
        type
        title
        body
        status
        failureReason
        sentAt
        createdAt
      }
      stats {
        total
        queuedCount
        sentCount
        deliveredCount
        failedCount
        droppedCount
      }
      totalCount
    }
  }
`;
